// src/MarkdownRenderer.js
import React from 'react';
import ReactMarkdown from 'react-markdown';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {darcula} from 'react-syntax-highlighter/dist/esm/styles/prism';

export const MarkdownRenderer = ({children}: any) => {
    return (
        <ReactMarkdown
            components={{
                code({ className, children, ...props}: any) {
                    const match = /language-(\w+)/.exec(className || '');
                    return match ? (
                        <SyntaxHighlighter style={darcula} language={match[1]} PreTag="div" {...props}>
                            {String(children).replace(/\n$/, '')}
                        </SyntaxHighlighter>
                    ) : (
                        <code className={className} {...props}>
                            {children}
                        </code>
                    );
                }
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

export default MarkdownRenderer;
